<template>
    <div>
        <transition name="slide-fade" mode="out-in">
            <div key="firstForm">
                <form ref="intervention_add" @submit.prevent="checkInterventionForm">
                    <md-card>
                        <md-card-header class="md-card-header-icon md-card-header-blue">
                            <div class="md-layout">
                                <div class="md-layout-item">
                                    <div class="card-icon">
                                        <i class="fas fa-2x fa-bars"></i>
                                    </div>
                                    <h4 class="title">Ajouter une intervention</h4>
                                </div>
                            </div>
                        </md-card-header>
                        <md-card-content>
                            <intervention-form :intervention="intervention" :errors="errors"></intervention-form>
                        </md-card-content>
                        <md-card-actions md-alignment="left">
                            <md-button type="submit" class="md-success" :disabled="isDisabled">
                                Enregistrer
                            </md-button>
                            <md-button class="md-warning" @click="goBack">
                                Retour
                            </md-button>
                        </md-card-actions>
                    </md-card>
                </form>
            </div>
        </transition>
    </div>
</template>

<script>
import InterventionForm from "./components/InterventionForm";

export default {
    name: "InterventionAdd",
    components: {
        InterventionForm,
    },
    data() {
        return {
            intervention: {
                category: null,
                type: null,
                client: null,
                site: null,
                contract: null,
                dates: [{
                    month: {
                        number: parseInt(this.$moment().format('M')),
                        label: this.$moment().format('MMMM'),
                    },
                    year: this.$moment().year(),
                    duration: '00:00',
                    comment: null,
                    hours: '0',
                    minutes: '0'
                }]
            },
            errors: [],
            types : [],
            isWaiting: false
        }
    },
    methods: {
        checkInterventionForm() {
            this.errors = []

            this.intervention.dates.forEach((date, index) => {
                if (date.duration === '') {
                    this.errors.push({
                        source: { pointer: '/data/attributes/date-'+index },
                        detail: 'La durée est obligatoire'
                    })
                }
            })

            if (this.errors.length <= 0) {
                this.submitInterventionForm()
            }
        },
        async submitInterventionForm() {
            if (!this.isWaiting) {
                this.isWaiting = true
                let intervention = {
                    category_id: this.intervention.category.id,
                    site_id: this.intervention.site.id,
                    contract_id: this.intervention.contract ? this.intervention.contract.id : null,
                    type_id: this.intervention.type.id,
                    dates: this.intervention.dates
                }

                try {
                    await this.$store.dispatch('interventions/addIntervention', intervention)
                    await this.$store.dispatch("alerts/success", "Intervention ajoutée")
                    this.isFirstFormValidated = true
                    const params = {}
                    const query = {
                        clientId: this.intervention.client.id,
                        siteId: intervention.site_id,
                        year: this.intervention.dates[0].year,
                        type: 'oneTimes'
                    }
                    this.$router.push({ name: 'Planning Management', params, query })
                } catch (e) {
                    if (e.response.status === 500) {
                        await this.$store.dispatch("alerts/error", e.response.data)
                    } else {
                        this.errors = e.response.data.errors
                    }
                }
                this.isWaiting = false
            }
        },
        goBack() {
            this.$router.back()
        },
    },
    computed: {
        isDisabled() {
            return !this.intervention.client || !this.intervention.site || !this.intervention.type
        }
    },
}
</script>

<style lang="scss">
.slide-fade-enter-active {
    transition: all .3s ease;
}

.slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
</style>
